import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/school/:id',
    name: 'School',
    component: () => import('@/views/school/index.vue')
  },
  {
    path: '/live/:id',
    name: 'Live',
    component: () => import('@/views/live/index.vue')
  }
]

const router = new VueRouter({ routes })

export default router
